export default {
      id: "circle__video-event-usage",
      viewBox: "0 0 28 27",
      url: __webpack_public_path__ + "img/icons.svg#circle__video-event",
      toString: function () {
        return this.url;
      }
    }